import React, { useEffect, useState, useRef } from "react";
import { RotateCw, Calendar, ArrowBigLeft } from "lucide-react";
import mission_logo from "../assets/mission_logo.svg";
import "@fontsource/plus-jakarta-sans";
import CalendarComponent from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { messaging } from "../firebase.js";
import bell from "../assets/icons8-settings-48.png";
import MealCard from "../components/MealCard.jsx";
import { useNavigate } from "react-router-dom";

const Projection = () => {
  const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/projection/getMealsCount`;
  const apiPlateCount = `${process.env.REACT_APP_API_BASE_URL}/projection/getPlateCount`;
  const [data, setData] = useState(null);
  const [PlateCount, setPlateCount] = useState(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [loader, setLoader] = useState(false);
  const [isLoading, setIsLoading] = useState({});
  const [TableData, setTableData] = useState([]);
  const [showAtmarpitView, setShowAtmarpitView] = useState(false);
  const [activeProjectionTab, setActiveProjectionTab] = useState("total");
  const [isAtmarpitDetailView, setIsAtmarpitDetailView] = useState(false);
  const [selectedAtmarpitCategory, setSelectedAtmarpitCategory] = useState("");

  const calendarRef = useRef(null);
  const navigate = useNavigate();

  const handleBoxClick = async (id) => {
    setIsLoading((prev) => ({ ...prev, [id]: true }));
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(selectedDate.getTime() + istOffset);
    const FinalDate = istDate.toISOString().split("T")[0];
    const requestBody = {
      date: FinalDate,
      categoryId: id,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/projection/getPurchasedUserList`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      const result = await response.json();

      if (result.success) {
        setTableData(result?.data?.purchaseList);
      } else {
        console.error("Failed to fetch data. Status:", response.status);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading((prev) => ({ ...prev, [id]: false }));
    }
  };

  const handleOpenSettings = () => {
    const userAgent = navigator.userAgent;

    if (userAgent.includes("Chrome")) {
      alert(
        "Go to Chrome settings: Settings > Privacy and security > Site settings."
      );
    } else if (userAgent.includes("Firefox")) {
      alert(
        "Go to Firefox settings: Settings > Privacy & Security > Permissions > Notifications."
      );
    } else if (userAgent.includes("Safari")) {
      alert("Go to Safari settings: Preferences > Websites > Notifications.");
    } else if (userAgent.includes("Edge")) {
      alert(
        "Go to Edge settings: Settings > Site permissions > Notifications."
      );
    } else if (userAgent.includes("Opera")) {
      alert("Go to Opera settings: Settings > Site settings > Notifications.");
    } else {
      alert(
        "Browser not recognized. Please check your browser's documentation for notification settings."
      );
    }
  };

  useEffect(() => {
    // Function to request notification permission
    const requestPermission = async () => {
      if (Notification.permission === "default") {
        try {
          const permission = await Notification.requestPermission();
          console.log("Notification permission response:", permission);
          if (permission === "granted" && messaging) {
            try {
              const newToken = await messaging.getToken();
              if (newToken) {
                localStorage.setItem("fcmMemberToken", newToken);
                const memberId = localStorage.getItem("memberGid");
                if (memberId) {
                  fetch(
                    `${process.env.REACT_APP_API_BASE_URL}/projection/saveMemberFCMToken`,
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify({
                        fcm_tokenid: newToken,
                        memberid: memberId,
                      }),
                    }
                  ).catch((err) =>
                    console.error("Error saving FCM token:", err)
                  );
                }
              }
            } catch (err) {
              console.warn(
                "Error getting FCM token after permission granted:",
                err
              );
            }
          }
          getToken();
        } catch (error) {
          console.error("Notification permission denied:", error);
        }
      } else if (Notification.permission === "granted") {
        // If permission is already granted, get the token
        getToken();
        console.log("Notification permission was already granted.");
      } else {
        console.warn("Notification permission has been denied.");
      }
    };

    // Function to get and store the FCM token
    const getToken = async () => {
      try {
        const currentToken = localStorage.getItem("fcmMemberToken");
        if (!currentToken) {
          navigate("/login");
        } else {
          console.log("FCM Token already exists:", currentToken);
        }
      } catch (error) {
        console.error("Error getting FCM token:", error);
      }
    };

    // Listen for token refreshes (messaging is null where push is unsupported)
    if (messaging) {
      messaging.onMessage((payload) => {
        console.log("Message received. ", payload);
        // Handle the incoming message as needed
      });
    }

    // Request notification permission and get token
    if (typeof Notification !== "undefined") {
      requestPermission();
    } else {
      getToken();
    }
  });

  // useEffect(() => {
  //   const hasTokenBeenSent = localStorage.getItem("fcmTokenSent");

  //   if (hasTokenBeenSent !== "true") {
  //     Notification.requestPermission()
  //       .then((permission) => {
  //         if (permission === "granted") {
  //           console.log("Notification permission granted.");
  //           return messaging.getToken();
  //         } else {
  //           console.warn("Notification permission not granted.");
  //           throw new Error("Notification permission not granted.");
  //         }
  //       })
  //       .then((token) => {
  //         if (!hasTokenBeenSent) {
  //           console.log("FCM token obtained:", token);
  //           saveFCMToken(token);
  //           console.log("FCM token sent");
  //         } else {
  //           console.log("FCM token has already been sent.");
  //         }
  //       })
  //       .catch((error) => {
  //         console.error(
  //           "Error in notification permission or token retrieval:",
  //           error
  //         );
  //       });
  //   } else {
  //     console.log(
  //       "FCM token has already been sent. Skipping saveFCMToken call."
  //     );
  //   }
  // }, []);

  // const requestNotificationPermission = async () => {
  //   if ("Notification" in window) {
  //     const permission = await Notification.requestPermission();
  //     if (permission === "granted") {
  //       console.log("Permission granted inside requestNotificationPermission.");
  //     } else {
  //       console.warn(
  //         "Permission not granted inside requestNotificationPermission."
  //       );
  //     }
  //   }
  // };

  // useEffect(() => {
  //   requestNotificationPermission();
  // }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      window.location.reload();
    }, 300000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true);

      const istOffset = 5.5 * 60 * 60 * 1000;
      const istDate = new Date(selectedDate.getTime() + istOffset);

      const requestBody = {
        date: istDate.toISOString().split("T")[0],
      };

      try {
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responseTwo = await fetch(apiPlateCount, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const result = await response.json();
        const resultPlateCount = await responseTwo.json();
        setData(result?.data?.meals);
        setPlateCount(resultPlateCount?.data?.meals);

        if (result.isSuccess) {
          console.log("yippie");
        } else {
          console.error("Error: " + result.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoader(false);
      }
    };

    fetchData();
  }, [selectedDate, apiUrl, apiPlateCount]);

  const handleClickOutside = (event) => {
    if (calendarRef.current && !calendarRef.current.contains(event.target)) {
      setIsCalendarOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const formatDate = (dateString) => {
    const options = {
      day: "numeric",
      month: "long",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      timeZone: "UTC",
    };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", options);
  };

  const currentHour = new Date().getHours();
  let initialExpandedIndex;

  if (currentHour >= 7 && currentHour < 10) {
    initialExpandedIndex = 0;
  } else if (currentHour >= 10 && currentHour < 15) {
    initialExpandedIndex = 1;
  } else if (currentHour >= 15 && currentHour < 19) {
    initialExpandedIndex = 2;
  } else {
    initialExpandedIndex = 0;
  }

  const MealCardContainer = ({ meals, PlateCount }) => {
    const [expandedIndex, setExpandedIndex] = useState(initialExpandedIndex);

    const getNumericCount = (value) => {
      const n = Number(value);
      return Number.isFinite(n) ? n : 0;
    };

    const getSalesByCategory = (category) =>
      getNumericCount(
        meals?.sales?.find((meal) => meal.Category === category)?.Count
      );

    const getRecentSalesByCategory = (category) =>
      getNumericCount(
        meals?.recentSales?.find((meal) => meal.Category === category)?.Count
      );

    const getMealData = (mealName) => {
      const currentTime = new Date();
      const currentDate = currentTime?.getDate();
      const selectedCurrentDate = selectedDate?.getDate();

      const mealTimes = {
        Breakfast: new Date(
          currentTime.getFullYear(),
          currentTime.getMonth(),
          currentTime.getDate(),
          8,
          0,
          0
        ),
        Lunch: new Date(
          currentTime.getFullYear(),
          currentTime.getMonth(),
          currentTime.getDate(),
          12,
          0,
          0
        ),
        Dinner: new Date(
          currentTime.getFullYear(),
          currentTime.getMonth(),
          currentTime.getDate(),
          17,
          0,
          0
        ),
      };

      let timeLeftDisplay = "";

      if (
        currentTime < mealTimes[mealName] &&
        currentDate === selectedCurrentDate
      ) {
        const timeDifference = mealTimes[mealName] - currentTime;

        const hoursLeft = Math.floor(timeDifference / (1000 * 60 * 60));
        const minutesLeft = Math.floor(
          (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
        );

        timeLeftDisplay = `${hoursLeft}h ${minutesLeft}min`;
      }

      const projectedRegular = meals?.projected?.filter(
        (meal) => meal.Proj_Category === mealName
      );

      const projectedVegan = meals?.projected?.filter(
        (meal) => meal.Proj_Category === `Vegan ${mealName}`
      );

      const totalPlannedRegular =
        projectedRegular?.length > 0 ? Number(projectedRegular[0].Proj_Counts) : 0;
      const totalPlannedVegan =
        projectedVegan?.length > 0 ? Number(projectedVegan[0].Proj_Counts) : 0;

      // For vegan meals, backend sends category names like "Vegan Breakfast" etc.
      // but Day Food Pass is common for both tabs.
      const isVeganTab = activeProjectionTab === "vegan";
      const isTotalTab = activeProjectionTab === "total";

      const regularCategory = mealName;
      const veganCategory = `Vegan ${mealName}`;

      const mainMealSale = isTotalTab
        ? getSalesByCategory(regularCategory) + getSalesByCategory(veganCategory)
        : getSalesByCategory(isVeganTab ? veganCategory : regularCategory);

      const dayFoodPassSale = isTotalTab
        ? getSalesByCategory("Day Food Pass") + getSalesByCategory("Vegan Day Food Pass")
        : getSalesByCategory(isVeganTab ? "Vegan Day Food Pass" : "Day Food Pass");

      const paryushanSale = getSalesByCategory("Paryushan Food Pass");

      const totalSales = mainMealSale + dayFoodPassSale + paryushanSale;

      const totalPlanned = isTotalTab
        ? getNumericCount(totalPlannedRegular) + getNumericCount(totalPlannedVegan)
        : getNumericCount(isVeganTab ? totalPlannedVegan : totalPlannedRegular);

      const surplusOrDeficit = totalPlanned - totalSales;

      const last30MinsSales = isTotalTab
        ? getRecentSalesByCategory(regularCategory) +
        getRecentSalesByCategory(veganCategory)
        : getRecentSalesByCategory(isVeganTab ? veganCategory : regularCategory);

      const last30minDayFoodPassSale = isTotalTab
        ? getRecentSalesByCategory("Day Food Pass") +
        getRecentSalesByCategory("Vegan Day Food Pass")
        : getRecentSalesByCategory(isVeganTab ? "Vegan Day Food Pass" : "Day Food Pass");

      const last30minParyushanSale = getRecentSalesByCategory(
        "Paryushan Food Pass"
      );

      const totalLast30MinsSales =
        last30MinsSales + last30minDayFoodPassSale + last30minParyushanSale;

      return {
        totalPlanned,
        totalSales,
        surplus: surplusOrDeficit >= 0 ? surplusOrDeficit : undefined,
        deficit: surplusOrDeficit < 0 ? Math.abs(surplusOrDeficit) : undefined,
        time: timeLeftDisplay,
        last30MinsSales: totalLast30MinsSales,
      };
    };

    const getPlateCount = (categoryName) => {
      const PlCount = PlateCount?.plateCount?.find(
        (meal) => meal.Category === categoryName
      );
      return PlCount ? PlCount.Counts : "-";
    };

    const getScannedCount = (categoryName) => {
      const PlCount = PlateCount?.scannedCount?.find(
        (meal) => meal.Category === categoryName
      );
      return PlCount ? PlCount.Counts : "-";
    };

    const getCombinedPlateCount = (baseMealName) => {
      const reg = getNumericCount(getPlateCount(baseMealName));
      const veg = getNumericCount(getPlateCount(`Vegan ${baseMealName}`));
      const total = reg + veg;
      return total === 0 ? "-" : total;
    };

    const getCombinedScannedCount = (baseMealName) => {
      const reg = getNumericCount(getScannedCount(baseMealName));
      const veg = getNumericCount(getScannedCount(`Vegan ${baseMealName}`));
      const total = reg + veg;
      return total === 0 ? "-" : total;
    };

    const baseMealNames = ["Breakfast", "Lunch", "Dinner"];

    return (
      <div className="relative">
        {baseMealNames.map((mealName, index) => {
          const mealData = getMealData(mealName);

          const plateCount =
            activeProjectionTab === "total"
              ? getCombinedPlateCount(mealName)
              : activeProjectionTab === "vegan"
                ? getPlateCount(`Vegan ${mealName}`)
                : getPlateCount(mealName);

          const scannedCount =
            activeProjectionTab === "total"
              ? getCombinedScannedCount(mealName)
              : activeProjectionTab === "vegan"
                ? getScannedCount(`Vegan ${mealName}`)
                : getScannedCount(mealName);

          const displayMealName = mealName;

          return (
            <MealCard
              key={index}
              meal={displayMealName}
              data={mealData}
              isExpanded={expandedIndex === index}
              onToggle={() =>
                setExpandedIndex(expandedIndex === index ? null : index)
              }
              plateCount={plateCount}
              scannedCount={scannedCount}
            />
          );
        })}
      </div>
    );
  };

  const getSalesCount = (categoryName) => {
    const sales = data?.sales?.find((meal) => meal.Category === categoryName);
    return sales ? sales.Count : "-";
  };

  const breakfastTags = data?.tags?.find((tag) => tag.Category === "Breakfast");

  const foodPacketCount =
    data?.sales?.find((item) => item.Category === "Food Packet")?.Count || "-";

  const sadhanaBhattiCount =
    data?.sales
      ?.filter((item) => item.Category?.includes("Sadhana Bhatti"))
      ?.reduce((total, item) => total + (Number(item.Count) || 0), 0) || "-";

  const getAtmarpitCount = (categoryName) => {
    const baseCount =
      data?.atmarpitCounts?.find((item) => item.Category === categoryName)
        ?.Count || 0;

    // Business rule: "Vegan Day Food Pass" applies for all vegan meals,
    // so show it added into Vegan Breakfast/Lunch/Dinner tiles.
    if (
      categoryName === "Vegan Breakfast" ||
      categoryName === "Vegan Lunch" ||
      categoryName === "Vegan Dinner"
    ) {
      const veganDayFoodPassCount =
        data?.atmarpitCounts?.find(
          (item) => item.Category === "Vegan Day Food Pass"
        )?.Count || 0;
      return (Number(baseCount) || 0) + (Number(veganDayFoodPassCount) || 0);
    }

    return Number(baseCount) || 0;
  };

  console.log("data", data);

  return (
    <div className="max-w-md mx-auto bg-white min-h-screen font-jakarta shadow-lg">
      <header className="flex justify-between items-center p-4 bg-white shadow-2xl">
        <div className="w-12 h-12">
          <img
            src={mission_logo}
            alt="Logo"
            className="max-w-6xl max-h-screen object-contain"
          />
        </div>
        <div className="font-jakarta font-bold text-xl ml-5">
          SRMD Meal Tracker
        </div>
        <div className="flex space-x-4">
          <RotateCw
            className="w-6 h-6 text-pink-500 cursor-pointer"
            onClick={() => window.location.reload()}
          />
          {(TableData?.length > 0 || showAtmarpitView || isAtmarpitDetailView) && (
            <ArrowBigLeft
              className="w-7 h-7 text-pink-500 cursor-pointer"
              onClick={() => {
                if (isAtmarpitDetailView) {
                  setIsAtmarpitDetailView(false);
                  setTableData([]);
                  setShowAtmarpitView(true);
                } else {
                  setTableData([]);
                  setShowAtmarpitView(false);
                }
              }}
            />
          )}
          <button className="w-6 h-6" onClick={handleOpenSettings}>
            <img src={bell} alt="Bell Icon" className="w-full h-full" />
          </button>
        </div>
      </header>

      {TableData?.length === 0 && !showAtmarpitView && !isAtmarpitDetailView && (
        <>

          <div className="flex p-4 text-sm space-x-3 overflow-x-auto whitespace-nowrap">
            {breakfastTags &&
              ["Tag1Str", "Tag2Str", "Tag3Str"].map((tag) => {
                const tagValue = breakfastTags[tag] || null;
                return tagValue ? (
                  <button
                    key={tag}
                    className="bg-[#1F0F4A] text-white px-4 py-2 rounded-full mr-2 flex items-center"
                  >
                    {tagValue}
                    <i className="fas fa-check-circle ml-2 text-green-500"></i>
                  </button>
                ) : null;
              })}
          </div>


          <div className="flex items-center justify-center mb-6 mt-6">
            <div
              className="border border-dashed border-[#7031B9] rounded-2xl px-6 py-2 text-sm flex items-center justify-center cursor-pointer w-96"
              onClick={() => setIsCalendarOpen(true)}
            >
              <span className="text-[#333333]">
                {selectedDate.toLocaleDateString("en-US", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </span>

              <div className="ml-2 w-8 h-8 flex items-center justify-center rounded-full bg-[#E32CA6]">
                <Calendar className="w-5 h-5 text-white" />
              </div>
            </div>
          </div>

          {isCalendarOpen && (
            <div
              ref={calendarRef}
              className="absolute top-16 left-1/2 transform -translate-x-1/2 z-10 transition-opacity duration-300 ease-in-out"
            >
              <CalendarComponent
                onChange={(date) => {
                  setSelectedDate(date);
                  setIsCalendarOpen(false);
                }}
                value={selectedDate}
              />
            </div>
          )}
          {/* Tabs */}
          <div className="px-4 mb-4">
            <div className="flex rounded-2xl bg-[#F0F1F6] p-1">
              <button
                type="button"
                onClick={() => setActiveProjectionTab("total")}
                className={
                  activeProjectionTab === "total"
                    ? "flex-1 rounded-2xl bg-[#1F0F4A] py-2 text-sm font-semibold text-white shadow"
                    : "flex-1 rounded-2xl py-2 text-sm font-semibold text-[#1F0F4A]/70"
                }
              >
                Total
              </button>
              <button
                type="button"
                onClick={() => setActiveProjectionTab("regular")}
                className={
                  activeProjectionTab === "regular"
                    ? "flex-1 rounded-2xl bg-[#1F0F4A] py-2 text-sm font-semibold text-white shadow"
                    : "flex-1 rounded-2xl py-2 text-sm font-semibold text-[#1F0F4A]/70"
                }
              >
                Regular
              </button>
              <button
                type="button"
                onClick={() => setActiveProjectionTab("vegan")}
                className={
                  activeProjectionTab === "vegan"
                    ? "flex-1 rounded-2xl bg-[#1F0F4A] py-2 text-sm font-semibold text-white shadow"
                    : "flex-1 rounded-2xl py-2 text-sm font-semibold text-[#1F0F4A]/70"
                }
              >
                Vegan
              </button>

            </div>


          </div>
          {loader ? (
            <div className="flex justify-center items-center py-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1.5em"
                height="1.5em"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#1F0F4A"
                  d="M20.27,4.74a4.93,4.93,0,0,1,1.52,4.61,5.32,5.32,0,0,1-4.1,4.51,5.12,5.12,0,0,1-5.2-1.5,5.53,5.53,0,0,0,6.13-1.48A5.66,5.66,0,0,0,20.27,4.74ZM12.32,11.53a5.49,5.49,0,0,0-1.47-6.2A5.57,5.57,0,0,0,4.71,3.72,5.17,5.17,0,0,1,9.53,2.2,5.52,5.52,0,0,1,13.9,6.45,5.28,5.28,0,0,1,12.32,11.53ZM19.2,20.29a4.92,4.92,0,0,1-4.72,1.49,5.32,5.32,0,0,1-4.34-4.05A5.2,5.2,0,0,1,11.6,12.5a5.6,5.6,0,0,0,1.51,6.13A5.63,5.63,0,0,0,19.2,20.29ZM3.79,19.38A5.18,5.18,0,0,1,2.32,14a5.3,5.3,0,0,1,4.59-4,5,5,0,0,1,4.58,1.61,5.55,5.55,0,0,0-6.32,1.69A5.46,5.46,0,0,0,3.79,19.38ZM12.23,12a5.11,5.11,0,0,0,3.66-5,5.75,5.75,0,0,0-3.18-6,5,5,0,0,1,4.42,2.3,5.21,5.21,0,0,1,.24,5.92A5.4,5.4,0,0,1,12.23,12ZM11.76,12a5.18,5.18,0,0,0-3.68,5.09,5.58,5.58,0,0,0,3.19,5.79c-1,.35-2.9-.46-4-1.68A5.51,5.51,0,0,1,11.76,12ZM23,12.63a5.07,5.07,0,0,1-2.35,4.52,5.23,5.23,0,0,1-5.91.2,5.24,5.24,0,0,1-2.67-4.77,5.51,5.51,0,0,0,5.45,3.33A5.52,5.52,0,0,0,23,12.63ZM1,11.23a5,5,0,0,1,2.49-4.5,5.23,5.23,0,0,1,5.81-.06,5.3,5.3,0,0,1,2.61,4.74A5.56,5.56,0,0,0,6.56,8.06,5.71,5.71,0,0,0,1,11.23Z"
                >
                  <animateTransform
                    attributeName="transform"
                    dur="1.5s"
                    repeatCount="indefinite"
                    type="rotate"
                    values="0 12 12;360 12 12"
                  />
                </path>
              </svg>
            </div>
          ) : (
            <>
              <MealCardContainer meals={data} PlateCount={PlateCount} />

              {/* Additional Div Included in Else Condition */}
              {activeProjectionTab === "total" && (
                <>
                  <div className="flex mx-4 mb-4 mt-4 pb-1">
                    {isLoading[57] ? (
                      <div className="flex justify-center items-center py-4 bg-[#F0F1F6] rounded-3xl p-4 w-1/2 mr-2">
                        {/* Loader SVG */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="1.5em"
                          height="1.5em"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="#1F0F4A"
                            d="M20.27,4.74a4.93,4.93,0,0,1,1.52,4.61,5.32,5.32,0,0,1-4.1,4.51,5.12,5.12,0,0,1-5.2-1.5,5.53,5.53,0,0,0,6.13-1.48A5.66,5.66,0,0,0,20.27,4.74ZM12.32,11.53a5.49,5.49,0,0,0-1.47-6.2A5.57,5.57,0,0,0,4.71,3.72,5.17,5.17,0,0,1,9.53,2.2,5.52,5.52,0,0,1,13.9,6.45,5.28,5.28,0,0,1,12.32,11.53ZM19.2,20.29a4.92,4.92,0,0,1-4.72,1.49,5.32,5.32,0,0,1-4.34-4.05A5.2,5.2,0,0,1,11.6,12.5a5.6,5.6,0,0,0,1.51,6.13A5.63,5.63,0,0,0,19.2,20.29ZM3.79,19.38A5.18,5.18,0,0,1,2.32,14a5.3,5.3,0,0,1,4.59-4,5,5,0,0,1,4.58,1.61,5.55,5.55,0,0,0-6.32,1.69A5.46,5.46,0,0,0,3.79,19.38ZM12.23,12a5.11,5.11,0,0,0,3.66-5,5.75,5.75,0,0,0-3.18-6,5,5,0,0,1,4.42,2.3,5.21,5.21,0,0,1,.24,5.92A5.4,5.4,0,0,1,12.23,12ZM11.76,12a5.18,5.18,0,0,0-3.68,5.09,5.58,5.58,0,0,0,3.19,5.79c-1,.35-2.9-.46-4-1.68A5.51,5.51,0,0,1,11.76,12ZM23,12.63a5.07,5.07,0,0,1-2.35,4.52,5.23,5.23,0,0,1-5.91.2,5.24,5.24,0,0,1-2.67-4.77,5.51,5.51,0,0,0,5.45,3.33A5.52,5.52,0,0,0,23,12.63ZM1,11.23a5,5,0,0,1,2.49-4.5,5.23,5.23,0,0,1,5.81-.06,5.3,5.3,0,0,1,2.61,4.74A5.56,5.56,0,0,0,6.56,8.06,5.71,5.71,0,0,0,1,11.23Z"
                          >
                            <animateTransform
                              attributeName="transform"
                              dur="1.5s"
                              repeatCount="indefinite"
                              type="rotate"
                              values="0 12 12;360 12 12"
                            />
                          </path>
                        </svg>
                      </div>
                    ) : (
                      <div
                        className="bg-[#F0F1F6] rounded-3xl p-4 w-1/2 mr-2 cursor-pointer"
                        onClick={() => {
                          if (getSalesCount("Ayambil") !== "-") {
                            handleBoxClick(57);
                          }
                        }}
                      >
                        <div className="text-indigo-900 font-jakarta font-semibold mb-2">
                          Ayambil
                        </div>
                        <div className="text-5xl font-jakarta text-pink-500">
                          {getSalesCount("Ayambil")}
                        </div>
                      </div>
                    )}
                    {isLoading[20] ? (
                      <div className="flex justify-center items-center py-4 bg-[#F0F1F6] rounded-3xl p-4 w-1/2 mr-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="1.5em"
                          height="1.5em"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="#1F0F4A"
                            d="M20.27,4.74a4.93,4.93,0,0,1,1.52,4.61,5.32,5.32,0,0,1-4.1,4.51,5.12,5.12,0,0,1-5.2-1.5,5.53,5.53,0,0,0,6.13-1.48A5.66,5.66,0,0,0,20.27,4.74ZM12.32,11.53a5.49,5.49,0,0,0-1.47-6.2A5.57,5.57,0,0,0,4.71,3.72,5.17,5.17,0,0,1,9.53,2.2,5.52,5.52,0,0,1,13.9,6.45,5.28,5.28,0,0,1,12.32,11.53ZM19.2,20.29a4.92,4.92,0,0,1-4.72,1.49,5.32,5.32,0,0,1-4.34-4.05A5.2,5.2,0,0,1,11.6,12.5a5.6,5.6,0,0,0,1.51,6.13A5.63,5.63,0,0,0,19.2,20.29ZM3.79,19.38A5.18,5.18,0,0,1,2.32,14a5.3,5.3,0,0,1,4.59-4,5,5,0,0,1,4.58,1.61,5.55,5.55,0,0,0-6.32,1.69A5.46,5.46,0,0,0,3.79,19.38ZM12.23,12a5.11,5.11,0,0,0,3.66-5,5.75,5.75,0,0,0-3.18-6,5,5,0,0,1,4.42,2.3,5.21,5.21,0,0,1,.24,5.92A5.4,5.4,0,0,1,12.23,12ZM11.76,12a5.18,5.18,0,0,0-3.68,5.09,5.58,5.58,0,0,0,3.19,5.79c-1,.35-2.9-.46-4-1.68A5.51,5.51,0,0,1,11.76,12ZM23,12.63a5.07,5.07,0,0,1-2.35,4.52,5.23,5.23,0,0,1-5.91.2,5.24,5.24,0,0,1-2.67-4.77,5.51,5.51,0,0,0,5.45,3.33A5.52,5.52,0,0,0,23,12.63ZM1,11.23a5,5,0,0,1,2.49-4.5,5.23,5.23,0,0,1,5.81-.06,5.3,5.3,0,0,1,2.61,4.74A5.56,5.56,0,0,0,6.56,8.06,5.71,5.71,0,0,0,1,11.23Z"
                          >
                            <animateTransform
                              attributeName="transform"
                              dur="1.5s"
                              repeatCount="indefinite"
                              type="rotate"
                              values="0 12 12;360 12 12"
                            />
                          </path>
                        </svg>
                      </div>
                    ) : (
                      <div
                        className="bg-[#F0F1F6] rounded-3xl p-4 w-1/2 mr-2 cursor-pointer"
                        onClick={() => {
                          if (foodPacketCount !== "-") {
                            handleBoxClick(20);
                          }
                        }}
                      >
                        <div className="text-indigo-900 font-jakarta font-semibold mb-2">
                          Food Packets
                        </div>
                        <div className="text-5xl font-jakarta text-pink-500">
                          {foodPacketCount}
                        </div>
                      </div>
                    )}
                    <div
                      className="bg-[#F0F1F6] rounded-3xl p-4 w-1/2 mr-2"
                    >
                      <div className="text-indigo-900 font-jakarta font-semibold mb-2">
                        Sadhana Bhatti
                      </div>
                      <div className="text-5xl font-jakarta text-pink-500">
                        {sadhanaBhattiCount}
                      </div>
                    </div>
                  </div>
                  <div className="flex mx-4 my-4 px-1">
                    <div
                      className="bg-[#F0F1F6] rounded-3xl p-4 w-1/2 mr-2 cursor-pointer"
                      onClick={() => {
                        if (
                          data?.atmarpitCounts &&
                          data.atmarpitCounts.length > 0
                        ) {
                          setShowAtmarpitView(true);
                        }
                      }}
                    >
                      <div className="text-indigo-900 font-jakarta font-semibold mb-2">
                        Atmarpit Counts
                      </div>
                      <div className="text-5xl font-jakarta text-pink-500">
                        {data?.atmarpitCounts?.reduce(
                          (total, item) => {
                            const count = Number(item.Count) || 0;
                            // Business rule: Vegan Day Food Pass atmarpit counts should be tripled
                            if (item.Category === "Vegan Day Food Pass") {
                              return total + count * 3;
                            }
                            return total + count;
                          },
                          0
                        ) || "-"}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </>
      )}
      {TableData?.length > 0 && !isAtmarpitDetailView && (
        <div className="overflow-x-auto w-full">
          <div className="flex items-center justify-center mb-6 mt-6">
            <div
              className="border border-dashed border-[#7031B9] rounded-2xl px-6 py-2 text-sm flex items-center justify-center w-96"
            >
              <span className="text-[#333333]">
                {selectedDate.toLocaleDateString("en-US", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </span>
            </div>
          </div>
          <table className="w-full border border-gray-300">
            <thead>
              <tr className="bg-[#1f0f4a] text-white border-b border-gray-300 w-full">
                <th className="py-2 text-sm sm:text-md  w-1/3 border-r border-gray-300">
                  NAME
                </th>
                <th className="py-2 text-sm sm:text-md  w-1/3 border-r border-gray-300">
                  MOBILE <br />
                  NUMBER
                </th>
                <th className="py-2 text-sm sm:text-md w-1/3">{TableData[0].CategoryId === 20 ? "REMARKS" : "PURCHASE DATE"}</th>
              </tr>
            </thead>
            <tbody>
              {TableData.map((item, index) => (
                <tr
                  key={index}
                  className="bg-[#ffffff] text-[#1f0f4a] border-b border-gray-300 w-full"
                >
                  <td className="px-1 pl-2 py-2 text-md text-left p-l-2 border-r w-1/4 sm:w-1/3 border-gray-300">
                    {item.BuyerName}<br /> {item.CategoryId === 20 ? `Qty: ${item.quantity}` : ""}
                  </td>
                  <td className="px-1 pl-2 py-2 text-md text-left border-r w-1/4 sm:w-1/3 border-gray-300">
                    {item.MobileNo ? (
                      <a href={`tel:${item.MobileNo}`} className="font-medium ">
                        {item.MobileNo}
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td className="px-1 py-2 text-sm w-2/4 sm:w-1/3">
                    {TableData[0].CategoryId === 20 ? item.Remarks : formatDate(item.bill_date)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {isAtmarpitDetailView && TableData?.length > 0 && (
        <div className="overflow-x-auto w-full">
          <div className="flex items-center justify-center mb-6 mt-6">
            <div className="border border-dashed border-[#7031B9] rounded-2xl px-6 py-2 text-sm flex items-center justify-center w-96">
              <span className="text-[#333333]">
                {selectedDate.toLocaleDateString("en-US", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}{" "}
                {selectedAtmarpitCategory
                  ? `- ${selectedAtmarpitCategory} Atmarpits`
                  : ""}
              </span>
            </div>
          </div>
          <table className="w-full border border-gray-300">
            <thead>
              <tr className="bg-[#1f0f4a] text-white border-b border-gray-300 w-full">
                <th className="py-2 text-sm sm:text-md border-gray-300">
                  NAME
                </th>
                <th className="py-2 text-sm sm:text-md border-gray-300">
                  Date
                </th>
              </tr>
            </thead>
            <tbody>
              {TableData.map((item, index) => (
                <tr
                  key={index}
                  className="bg-[#ffffff] text-[#1f0f4a] border-b border-gray-300 w-full"
                >
                  <td className="px-1 pl-2 py-2 text-md text-left border-gray-300">
                    {item.FirstName} {item.LastName}
                  </td>
                  <td className="px-1 pl-2 py-2 text-md text-left border-gray-300">
                    {item.PurchaseDate ? formatDate(item.PurchaseDate) : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {showAtmarpitView && !isAtmarpitDetailView && (
        <div className="overflow-x-auto w-full">
          <div className="flex items-center justify-center mb-6 mt-6">
            <div className="border border-dashed border-[#7031B9] rounded-2xl px-6 py-2 text-sm flex items-center justify-center w-96">
              <span className="text-[#333333]">
                {selectedDate.toLocaleDateString("en-US", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </span>
            </div>
          </div>
          <div className="grid grid-cols-2  gap-4 mx-4 mb-4 mt-4">
            <div
              className="bg-[#F0F1F6] rounded-3xl p-6 w-full cursor-pointer"
              onClick={() => {
                const list =
                  data?.atmarpitNames?.filter(
                    (item) => item.Category === "Breakfast"
                  ) || [];
                if (list.length > 0) {
                  setSelectedAtmarpitCategory("Breakfast");
                  setTableData(list);
                  setIsAtmarpitDetailView(true);
                  setShowAtmarpitView(false);
                }
              }}
            >
              <div className="text-indigo-900 font-jakarta font-semibold mb-2 text-lg">
                Breakfast
              </div>
              <div className="text-5xl font-jakarta text-pink-500">
                {getAtmarpitCount("Breakfast")}
              </div>
            </div>
            <div
              className="bg-[#F0F1F6] rounded-3xl p-6 w-full cursor-pointer"
              onClick={() => {
                const list =
                  data?.atmarpitNames?.filter(
                    (item) => ["Vegan Breakfast", "Vegan Day Food Pass"].includes(item.Category)
                  ) || [];
                if (list.length > 0) {
                  setSelectedAtmarpitCategory("Vegan Breakfast");
                  setTableData(list);
                  setIsAtmarpitDetailView(true);
                  setShowAtmarpitView(false);
                }
              }}
            >
              <div className="text-indigo-900 font-jakarta font-semibold mb-2 text-lg">
                Vegan Breakfast
              </div>
              <div className="text-5xl font-jakarta text-pink-500">
                {getAtmarpitCount("Vegan Breakfast")}
              </div>
            </div>

            <div
              className="bg-[#F0F1F6] rounded-3xl p-6 w-full cursor-pointer"
              onClick={() => {
                const list =
                  data?.atmarpitNames?.filter(
                    (item) => item.Category === "Lunch"
                  ) || [];
                if (list.length > 0) {
                  setSelectedAtmarpitCategory("Lunch");
                  setTableData(list);
                  setIsAtmarpitDetailView(true);
                  setShowAtmarpitView(false);
                }
              }}
            >
              <div className="text-indigo-900 font-jakarta font-semibold mb-2 text-lg">
                Lunch
              </div>
              <div className="text-5xl font-jakarta text-pink-500">
                {getAtmarpitCount("Lunch")}
              </div>
            </div>
            <div
              className="bg-[#F0F1F6] rounded-3xl p-6 w-full cursor-pointer"
              onClick={() => {

                const list =
                  data?.atmarpitNames?.filter(
                    (item) => ["Vegan Lunch", "Vegan Day Food Pass"].includes(item.Category)
                  ) || [];
                if (list.length > 0) {
                  setSelectedAtmarpitCategory("Vegan Lunch");
                  setTableData(list);
                  setIsAtmarpitDetailView(true);
                  setShowAtmarpitView(false);
                }
              }}
            >
              <div className="text-indigo-900 font-jakarta font-semibold mb-2 text-lg">
                Vegan Lunch
              </div>
              <div className="text-5xl font-jakarta text-pink-500">
                {getAtmarpitCount("Vegan Lunch")}
              </div>
            </div>
            <div
              className="bg-[#F0F1F6] rounded-3xl p-6 w-full cursor-pointer"
              onClick={() => {
                const list =
                  data?.atmarpitNames?.filter(
                    (item) => item.Category === "Dinner"
                  ) || [];
                if (list.length > 0) {
                  setSelectedAtmarpitCategory("Dinner");
                  setTableData(list);
                  setIsAtmarpitDetailView(true);
                  setShowAtmarpitView(false);
                }
              }}
            >
              <div className="text-indigo-900 font-jakarta font-semibold mb-2 text-lg">
                Dinner
              </div>
              <div className="text-5xl font-jakarta text-pink-500">
                {getAtmarpitCount("Dinner")}
              </div>
            </div>
            <div
              className="bg-[#F0F1F6] rounded-3xl p-6 w-full cursor-pointer"
              onClick={() => {
                const list =
                  data?.atmarpitNames?.filter(
                    (item) => ["Vegan Dinner", "Vegan Day Food Pass"].includes(item.Category)
                  ) || [];
                if (list.length > 0) {
                  setSelectedAtmarpitCategory("Vegan Dinner");
                  setTableData(list);
                  setIsAtmarpitDetailView(true);
                  setShowAtmarpitView(false);
                }
              }}
            >
              <div className="text-indigo-900 font-jakarta font-semibold mb-2 text-lg">
                Vegan Dinner
              </div>
              <div className="text-5xl font-jakarta text-pink-500">
                {getAtmarpitCount("Vegan Dinner")}
              </div>
            </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default Projection;
